import instanceAxios from '../config/api'
import i18n from '../i18n'
import {
  AverageActionsType,
  calculateSecurityCheckFamilyActionsCostsType,
  ExistingControlsbylabelType,
  GetBySWIFTSourceResponse,
  GetSecurityCheckFamilyBySourceResponse,
  globalMaturityRateISOType,
  globalMaturityRateNISTType,
  globalMaturityRateType,
  IntersectionByPerimetreForSecurityControlType,
  LateRateForSecurityControlType,
  MaturityRateType,
  RisksAndIncidentsByExistingControlType,
  RisksAndIncidentsBySecurityControlType,
  SecurityCheckFamily,
  SecurityCheckFamilyResponse,
  SecurityCheckFamilyResponseSCFS,
  SecurityCheckResponse,
  SecurityControlMatrixType,
  SecurityTree,
} from '../types/securityCheckFamilysTypes'
import { SecurityControls } from '../types/securityControls'
import {
  SubDomain,
  SubDomainResponse,
  SubDomainType,
} from '../types/subDomainTypes'
const API_URL = '/securityCheckFamilys'

export const getSecurityISOApi = async ({
  page,
  pageSize,
  language,
  source,
}: {
  page?: number
  pageSize?: number
  language?: string
  source?: string
}) => {
  try {
    const response = await instanceAxios.get<SecurityCheckFamilyResponse>(
      `${API_URL}/byISOSource`,
      {
        params: {
          page,
          pageSize,
          language,
          source,
        },
      }
    )
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch SEcurity ISO.')
  }
}

export const getSecuritySOCApi = async ({
  page,
  pageSize,
  language,
}: {
  page?: number
  pageSize?: number
  language?: string
}) => {
  try {
    const response = await instanceAxios.get<SecurityCheckFamilyResponse>(
      `${API_URL}/bySOCSource`,
      {
        params: { page, pageSize, language },
      }
    )
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch Security SOC.')
  }
}
export const getSecurityCheckFamilyBySWIFTSource = async (
  page = 1,
  pageSize = 10,
  language = i18n.language.toLocaleUpperCase()
): Promise<GetBySWIFTSourceResponse> => {
  try {
    const response = await instanceAxios.get<GetBySWIFTSourceResponse>(
      `${API_URL}/bySWIFTSource`,
      {
        params: { page, pageSize, language },
      }
    )
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch security check families by SWIFT source.')
  }
}
export const getAllSecurityCheckFamilys = async ({
  page,
  pageSize,
}: {
  page?: number
  pageSize?: number
}) => {
  try {
    const response = await instanceAxios.get<SecurityCheckFamilyResponse>(
      `securityCheckFamilys/`,
      {
        params: {
          page,
          pageSize,
        },
      }
    )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch SEcurity ISO.')
  }
}

export const getSecurityNISTApi = async ({
  page,
  pageSize,
  language,
}: {
  page?: number
  pageSize?: number
  language?: string
}) => {
  try {
    const response = await instanceAxios.get<SecurityCheckFamilyResponse>(
      `securityCheckFamilys/byNISTSource/`,
      {
        params: {
          page,
          pageSize,
          language,
        },
      }
    )
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch SecurityCheckFamily ISO.')
  }
}

export const addsecurityControlToActionApi = async ({
  securityCheckFamilies,
  securityControls,
  subDomains,
  _id,
}: {
  securityCheckFamilies: string[]
  securityControls: string[]
  subDomains: string[]
  _id: string
}): Promise<SecurityControls> => {
  try {
    const response = await instanceAxios.put<SecurityControls>(
      `actions/addSecurityControls/${_id}`,
      { securityCheckFamilies, securityControls, subDomains } // Passer les données à envoyer dans la requête
    )
    return response.data
  } catch (error) {
    console.log(error)
    throw new Error('Failed to PUT Action.')
  }
}

export const removeSubDomainFromActionApi = async (
  SubDomain: SubDomainType,
  _id: string
): Promise<SubDomain[]> => {
  try {
    const response = await instanceAxios.put<SubDomain[]>(
      `actions/removeSubDomain/${_id}`,
      SubDomain
    )
    console.log(response.data)
    return response.data
  } catch (error) {
    console.log(error)
    throw new Error('Failed to PUT Action.')
  }
}

export const getSecurityControlsApi = async (SecurityCheckId: string) => {
  try {
    const response = await instanceAxios.get<SecurityControls[]>(
      `securityCheckFamilys/getSecurityControl/` + SecurityCheckId
    )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch security controls.')
  }
}

export const getSecurityControlsbylistsecuritycheckApi = async (
  SecurityCheckId: string
) => {
  try {
    const response = await instanceAxios.get<SecurityControls[]>(
      `securityCheckFamilys/getSecurityControls/` + SecurityCheckId
    )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch security controls.')
  }
}

export const getSubDomainActionIdApi = async (ActionId: string) => {
  try {
    const response = await instanceAxios.get<SubDomainResponse>(
      `actions/getSubDomains/` + ActionId
    )
    return response
  } catch (error) {
    throw new Error('Failed to fetch SubDomains.')
  }
}

export const getGlobalMaturityRateApi = async () => {
  try {
    const response = await instanceAxios.get<globalMaturityRateType>(
      `securityCheckFamilys/getGlobalMaturityRate/`
    )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to get Global Maturity Rate.')
  }
}
export const getGlobalMaturityRateApiISO = async () => {
  try {
    const response = await instanceAxios.get<globalMaturityRateISOType>(
      `securityCheckFamilys/getGlobalMaturityISO/`
    )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to get Global Maturity Rate ISO.')
  }
}
export const getGlobalMaturityRateApiNSIT = async () => {
  try {
    const response = await instanceAxios.get<globalMaturityRateNISTType>(
      `securityCheckFamilys/getGlobalMaturityNSIT/`
    )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to get Global Maturity Rate NIST.')
  }
}

export const calculateSecurityCheckFamilyActionsCostsApi = async (
  SecurityCheckId: string
) => {
  try {
    const response =
      await instanceAxios.get<calculateSecurityCheckFamilyActionsCostsType>(
        `securityCheckFamilys/calculateSecurityCheckFamilyActionsCosts/` +
          SecurityCheckId
      )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to calculate Security CheckFamily Actions Costs.')
  }
}

export const getSecurityTreeByFamilyIdApi = async (SecurityCheckId: string) => {
  try {
    const response = await instanceAxios.get<SecurityTree>(
      `securityCheckFamilys/getSecurityTreeByFamilyId/` + SecurityCheckId
    )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to calculate Security CheckFamily Actions Costs.')
  }
}

export const securityControlMatrixApi = async () => {
  try {
    const response = await instanceAxios.get<SecurityControlMatrixType>(
      `securityControls/securityControlMatrix`
    )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to get security Control Matrix.')
  }
}

export const getRisksAndIncidentsBySecurityControlApi = async (
  SecurityControlId: string
) => {
  try {
    const response =
      await instanceAxios.get<RisksAndIncidentsBySecurityControlType>(
        `securityControls/getRisksAndIncidentsBySecurityControl/` +
          SecurityControlId
      )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to get Risks And Incidents By SecurityControl.')
  }
}

export const getIntersectionByPerimetreForSecurityControlApi = async (
  SecurityControlId: string
) => {
  try {
    const response =
      await instanceAxios.get<IntersectionByPerimetreForSecurityControlType>(
        `securityControls/getIntersectionByPerimetreForSecurityControl/` +
          SecurityControlId
      )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error(
      'Failed to get Intersection By Perimetre For SecurityControl.'
    )
  }
}

export const calculateAverageActionsForSecurityControlApi = async (
  SecurityControlId: string
) => {
  try {
    const response = await instanceAxios.get<AverageActionsType>(
      `securityControls/calculateAverageActionsForSecurityControl/` +
        SecurityControlId
    )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to calculate Average  Actions For SecurityControl.')
  }
}

export const CalculateLateRateForSecurityControlslApi = async (
  SecurityControlId: string
) => {
  try {
    const response = await instanceAxios.get<LateRateForSecurityControlType>(
      `securityControls/calculateLateRateForSecurityControls/` +
        SecurityControlId
    )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to  Calculate LateRate For Security Controls.')
  }
}

export const getRisksAndIncidentsByExistingControlApi = async (
  ExistingControlId: string
) => {
  try {
    const response =
      await instanceAxios.get<RisksAndIncidentsByExistingControlType>(
        `/ExistingControls/getRisksAndIncidentsByExistingControl` +
          ExistingControlId
      )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to  get Risks And Incidents By ExistingControl.')
  }
}

export const getExistingControlsByLabelApi = async ({
  label,
}: {
  label?: string
}) => {
  try {
    const response = await instanceAxios.get<ExistingControlsbylabelType>(
      `existingControls/getExistingControlsByLabel`,
      {
        params: {
          label,
        },
      }
    )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to get Existing Controls ByLabel.')
  }
}

export const getMaturityRateForExistingControlsApi = async () => {
  try {
    const response = await instanceAxios.get<MaturityRateType>(
      `/ExistingControls/getMaturityRateForExistingControls`
    )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to get Maturity  RateFor Existing Controls.')
  }
}
export const getwithSCFScores = async (
  language?: string
): Promise<SecurityCheckResponse> => {
  try {
    const response = await instanceAxios.get<SecurityCheckResponse>(
      `securityCheckFamilys/withSCFScores`,
      {
        params: { language },
      }
    )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error(
      'Failed to get the list of Security Check Families with Scores'
    )
  }
}
export const getwithSCFScoresByid = async (
  id: string,
  language?: string
): Promise<SecurityCheckFamilyResponseSCFS> => {
  try {
    const response = await instanceAxios.get<SecurityCheckFamilyResponseSCFS>(
      `securityCheckFamilys/withSCFScores/${id}`,
      {
        params: { language },
      }
    )
    return response.data
  } catch (error) {
    throw new Error('Failed to get Security Check Family with Scores')
  }
}
const fetchSecurityCheckFamilyBySource = async (
  source: 'SAMA' | 'NIS2' | 'SWIFT',
  page = 1,
  pageSize = 10,
  language = i18n.language.toLocaleUpperCase()
): Promise<GetSecurityCheckFamilyBySourceResponse> => {
  try {
    const response =
      await instanceAxios.get<GetSecurityCheckFamilyBySourceResponse>(
        `${API_URL}/by${source}Source?page=${page}&pageSize=${pageSize}&language=${language}`
      )
    return response.data
  } catch (error) {
    throw new Error(
      `Failed to fetch Security Check Families by ${source} Source.`
    )
  }
}

export const getSecurityCheckFamilyBySAMASource = (
  page?: number,
  pageSize?: number,
  language?: string
) => fetchSecurityCheckFamilyBySource('SAMA', page, pageSize, language)

export const getSecurityCheckFamilyByNIS2Source = (
  page?: number,
  pageSize?: number,
  language?: string
) => fetchSecurityCheckFamilyBySource('NIS2', page, pageSize, language)
